<template>
  <div class="bg">
    <div class="content">
      <el-form label-width="auto" label-position="left">
        <el-card>
          <el-row>
            <el-col :span="24">
              <el-form-item label="企业名称：">
                <span>
                  {{ detailInfo.name }}
                </span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="信用代码：">
                <span>
                  {{ detailInfo.code }}
                </span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="企业类型：">
                <span>
                  {{ detailInfo.type }}
                </span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="企业地址：">
                <span>
                  {{ detailInfo.enterpriseAddress }}
                </span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="法人姓名：">
                <span>{{ detailInfo.legalPerson }}</span>
              </el-form-item>
            </el-col>
            <el-form-item label="联系电话：">
              <span>{{ detailInfo.legalPhone }}</span>
            </el-form-item>
            <el-form-item v-if="detailInfo.remark !== ''" label="备注信息：">
              <span>{{ detailInfo.remark }}</span>
            </el-form-item>
            <el-form-item label="备注信息：">
              <span>无</span>
            </el-form-item>
          </el-row>
        </el-card>
      </el-form>
    </div>
  </div>
</template>
<script>
import { postDetail } from "@/api/app/enterprise";
export default {
  data() {
    return {
      detailInfo: {},
    };
  },
  created() {
    this.detail();
  },

  methods: {
    detail() {
      // 通过参建单位id获取详细信息
      postDetail(this.$store.state.app.itemId).then((res) => {
        this.detailInfo = res.data;
        this.$store.state.app.dict.find((item) => {
          if (res.data.type == item.value) {
            this.detailInfo.type = item.label;
          }
        });
      });
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  margin-bottom: 50px;
  padding: 10px;
  min-height: 100vh;
  background-color: #f0f0f0;
}
.content {
  .el-form-item {
    margin: 0px;
    font-size: 14px;
  }
  p {
    i {
      font-size: 12px;
    }
  }
  /deep/ .el-input__inner {
    border: unset;
    padding: 0;
  }
}
</style>
